import axios from 'axios'
import qs from 'qs'
import {
  getAlgoliaPlpProductsNormalized,
  getAlgoliaPlpFacetsNormalized,
} from '../algolia-normalizer'
import wcs from './index'
import VueCookies from 'vue-cookies'
import { getSAHingeFilterId, WORDLIFT_MAIN_URL } from '../utils/const'
import isEmpty from 'lodash/isEmpty'
import find from 'lodash/find'
import {
  getAlgoliaPlpFacets,
  algoliaPlpGroupedSearch,
  algoliaPlpUngroupedSearch,
  mergeProdsAndVariants,
  formatFacetsLogic,
  algoliaAnalyticsEvents,
  getSearchContentAndSuggestions,
  getPlpPageSize,
} from '../utils/algoliaIntegration'
import { getWishlistProducts } from '@libs/wcs/wishlist'
import { decodeFiltersI18n } from '../utils/algoliaIntegration'
import i18n from './../../i18n-setup'

let currentPlpCategory = window.algoliaConfig?.algoliaCategoryIdentifier || ''
const sortPrice = window.algoliaConfig?.isEarlyAccessParam
  ? 'sortPrice_EarlyAccess'
  : 'sortPrice_Guest'

const sortDiscount = window.algoliaConfig?.isEarlyAccessParam
  ? 'sortDiscount_EarlyAccess'
  : 'sortDiscount_Guest'

const hingeFilterIdSA = getSAHingeFilterId()

const clearUlr = (url, regex) => {
  // const tmpUrl = url.replace(/(\?|&)+(currentPage|orderBy){1}=([0-9]|default){1}/g, '').replace()
  const urlArray = url.split('&').reduce((acc, item) => {
    if (!!!item.match(regex)) {
      acc.push(item)
    }
    return acc
  }, [])
  return urlArray.join('&')
}
// lodash function to search an object in a nested array
const findValue = (arr, value) => {
  let result = {}
  find(arr, elem => {
    result = find(elem.list, { id: value })
    if (result)
      result = {
        facetIdentifier: result.facetIdentifier,
        groupName: elem.groupName,
        label: result.label,
      }
    return result
  })
  return result
}

//change price filter format to be compoatible with api call to be performed:
function replacePriceCall(filter) {
  return filter.includes('>')
    ? filter.replace('price:', `${sortPrice} `)
    : filter.replace('price:', `${sortPrice}: `)
}

// Retrieve applied filters and groupNames and returns a partial query string
const getConfigCMSBanners = payload => {
  let facetIdentifiers = ''
  let groupNames = ''
  let finalQueryString = ''

  let { filters, checkedFilters } = payload
  if (!isEmpty(checkedFilters)) {
    for (let indexCheckedFilter in checkedFilters) {
      const foundFilter = findValue(filters, checkedFilters[indexCheckedFilter])
      const fixedGroupName = foundFilter.groupName.replace('attributes_translated.', '')
      let facetIdentifier =
        foundFilter.groupName === 'price' ? foundFilter.label : foundFilter.facetIdentifier
      if (facetIdentifier.includes(':'))
        facetIdentifier = facetIdentifier.split(':')[1]
      if (facetIdentifier.includes('|'))
        facetIdentifier = facetIdentifier.split('|')[1]
      indexCheckedFilter == 0
        ? (facetIdentifiers = '&facetIdentifier=' + encodeURIComponent(facetIdentifier))
        : (facetIdentifiers += ',' + encodeURIComponent(facetIdentifier))
      indexCheckedFilter == 0
        ? (groupNames = '&facetName=' + encodeURIComponent(fixedGroupName))
        : (groupNames += ',' + encodeURIComponent(fixedGroupName))
    }
  }

  finalQueryString = facetIdentifiers + groupNames

  return finalQueryString
}

//called at first plp page load
export const getFiltersAndProducts = async payload => {
  const { extraFacets, searchTerm = '', idsFiltersCheckedList,plpIsExploded = false,currentPage = 1,currentProductsCount = 0,orderBy:orderByParam,  _retriedAfterEmptyFilters = false} = payload
  payload.currentPlpCategory = currentPlpCategory
  let normalizedFacetsAndProducts = []
  let facetParamsNormalized = []
  facetParamsNormalized = qs.parse(decodeURIComponent(window.location.search), {
    ignoreQueryPrefix: true,
  })

  payload.idsFiltersCheckedList =
    idsFiltersCheckedList
    ? [].concat(idsFiltersCheckedList)
    : facetParamsNormalized.facet
    ? [].concat(facetParamsNormalized.facet)
    : []

  const numericFiltersSelected = buildNumericFilters(payload.idsFiltersCheckedList)

  const algoliaFacetAndProductsPayload = {
    ...payload,
    ruleContexts:facetParamsNormalized.ruleContexts,
    numericFiltersSelected,
    searchTerm:facetParamsNormalized.searchTerm || searchTerm,
    currentPage,
    plpIsExploded,
    currentProductsCount,
  }
  normalizedFacetsAndProducts = await getAlgoliaPlpFacetsNormalized(
    await getAlgoliaPlpFacets(algoliaFacetAndProductsPayload),
    orderByParam
  )

  const hasNoResults = normalizedFacetsAndProducts?.numResult === 0 || normalizedFacetsAndProducts?.nbHits === 0 || !normalizedFacetsAndProducts?.hits?.length
  if (hasNoResults && payload.idsFiltersCheckedList.length > 0 && !_retriedAfterEmptyFilters) {
    return getFiltersAndProducts({
      ...payload,
      idsFiltersCheckedList: [],
      _retriedAfterEmptyFilters: true,
    })
  }

  //const {hits,page,hitsPerPage,nbPages,nbHits} = normalizedFacetsAndProducts
  // if exist a sortOptionsList and is defined the value selected override the default with the response from BE
  const orderBy =
    normalizedFacetsAndProducts.sortOptionsList && normalizedFacetsAndProducts.sortOptionsList.find(ele => ele.selected)
  if (orderBy) {
    facetParamsNormalized.orderBy = orderBy.id
  }
  let facetToSelect = (!_retriedAfterEmptyFilters && facetParamsNormalized.facet)
    ? [].concat(facetParamsNormalized.facet).map(ele => {
        let elementFacetNormalizedWithGroupName = normalizedFacetsAndProducts.filterOptionsList.find(item => {
          let e = null
          if (item.list) {
            e = item.list.find(l => ele === l.id)
          }
          return e
        })
        if (elementFacetNormalizedWithGroupName) {
          return {
            groupName: elementFacetNormalizedWithGroupName.groupName,
            id: ele,
          }
        } else if (ele.includes(hingeFilterIdSA)) {
          return {
            groupName: 'fit',
            id: decodeURIComponent(
              find(extraFacets, e => e.includes(hingeFilterIdSA))
            ),
          }
        }
      })
    : []

  // facetParamsNormalized.facet is necessary only to construct the facetToSelect, after that remove the property .facet
  delete facetParamsNormalized.facet //todo lasciare?
  // SGHDP-9181: replace the [undefined] with empty array []
  facetToSelect = facetToSelect.filter(y => y !== undefined)
  return {
    facetParams: facetParamsNormalized,
    facetToSelect: facetToSelect,
    redirect:normalizedFacetsAndProducts?.renderingContent?.redirect || null,
    ...normalizedFacetsAndProducts
  }
}

const mapFavoriteProducts = async productsPlp => {
  const wishlistProducts = await getWishlistProducts()
  wishlistProducts.products?.map(e => {
    productsPlp.hits.map(p => {
      if (p.productId === e.catentryId) {
        p.wishlistRelatedLinks = e.wishlistRelatedLinks
        p.wishlistRelatedLinks['isInWishlist'] = true
      }
    })
  })
  return productsPlp
}

//function to to get translated value for key attributes_translated.SALE in current language
export const getSaleFilterTranslated = () => {
  const saleTranslated = i18n.t('attributes_translated.SALE')
  return saleTranslated
}

// build nested numericFiltersSelected array, nesting translates to AND / OR in Algolia
export const buildNumericFilters = idsFiltersCheckedList => {
  let saleFilterTranslated = getSaleFilterTranslated()
  return idsFiltersCheckedList.reduce(
    (acc, filter) => {
      if (filter.toLowerCase().startsWith(saleFilterTranslated.toLowerCase())) {
        acc[0].push(`${sortDiscount}>0`)
      } else if (filter.toLowerCase().startsWith('price')) {
        acc[1].push(replacePriceCall(filter))
      }
      return acc
    },
    [[], []]
  )
}

export const getPlpProductsPayloadOptions = async function(payload) {
  //payload: facets selected
  var currentParamsUrl = qs.parse(decodeURIComponent(window.location.search), {
    ignoreQueryPrefix: true,
  })
  //TODO: if idsFiltersCheckedList is empty, avoid the following lines?
  const { idsFiltersCheckedList } = payload
  const facetFilters = await formatFacetsLogic(idsFiltersCheckedList)
  const categoryFacet = [`categories:${currentPlpCategory}`]
  const numericFiltersSelected = buildNumericFilters(idsFiltersCheckedList)

  if (categoryFacet) {
    facetFilters.push(categoryFacet)
  }
  if (facetFilters) {
    var filteredArray = facetFilters.filter(element => {
      return (
        !element[0]?.toLowerCase().startsWith('price') &&
        !element[0]?.toLowerCase().startsWith('sortdiscount')
      )
    })
  }

  const options = {
    page: currentParamsUrl.currentPage,
    hitsPerPage: getPlpPageSize(idsFiltersCheckedList.length > 0),
    facetFilters: filteredArray,
    numericFilters: numericFiltersSelected,
    orderBy: payload.orderBy,
    query: '',
    ruleContexts: currentParamsUrl.ruleContexts || '',
    userToken: VueCookies.get('_ALGOLIA'),
  }

  return {
    options,
  }
}
//get color variants, used only with algolia to delay ungrouped call
export const getProductsVariants = async payload => {
  const { productsData, options } = payload
  const { hits } = productsData || {}
  const variants = await algoliaPlpUngroupedSearch({ products: {hits}, options })
  //merge main products and variants:
  let productsFinal = mergeProdsAndVariants({ products: productsData, variants })
  return getAlgoliaPlpProductsNormalized(productsFinal)
}

//called at each facet update
//TODO : this could be removed and only getFiltersAndProducts should be used, but it is still used in some places
export const getPlpFacets = async payload => {
  const { orderBy, idsFiltersCheckedList, searchTerm } = payload

  const numericFiltersSelected = buildNumericFilters(idsFiltersCheckedList)

  payload.currentPlpCategory = currentPlpCategory
  payload.ruleContexts = payload.currentPlpCategory
  payload.numericFiltersSelected = numericFiltersSelected
  payload.searchTerm = searchTerm
  return getAlgoliaPlpFacetsNormalized(await getAlgoliaPlpFacets(payload), orderBy)
}

//called at product list update
export const getPlpProducts = async function(payload) {
  const { idsFiltersCheckedList } = payload
  const numericFiltersSelected = buildNumericFilters(idsFiltersCheckedList)
  const facetFilters = await formatFacetsLogic(idsFiltersCheckedList) //mergeFacetsForAlgoliaSearch(idsFiltersCheckedList) //formato desiderato: ["attributes.FRONT_COLOR_FACET:Yellow","attributes.FRONT_COLOR_FACET:Red"]
  const categoryFacet = [`categories:${currentPlpCategory}`]
  if (categoryFacet) {
    facetFilters.push(categoryFacet)
  }
  if (facetFilters) {
    var filteredArray = facetFilters.filter(element => {
      return (
        !element[0]?.toLowerCase().startsWith('price') &&
        !element[0]?.toLowerCase().startsWith('sortdiscount')
      )
    })
  }
  const options = {
    page: payload.currentPage,
    facetFilters: filteredArray,
    numericFilters: numericFiltersSelected,
    hitsPerPage: getPlpPageSize(idsFiltersCheckedList.length > 0),
    orderBy: payload.orderBy,
    query: payload.searchTerm || '',
    ruleContexts: payload.ruleContexts || '',
    userToken: VueCookies.get('_ALGOLIA'),
  }

  const products = await algoliaPlpGroupedSearch({ options })

  //retrieve variants with ungrouped index call
  if (!isEmpty(products.hits)) { //TODO why not use getProductsVariants
    const variants = await algoliaPlpUngroupedSearch({ products, options })
    //merge main products and variants:
    const productsFinal = mergeProdsAndVariants({ products, variants })
    const productsFinalMerged = await mapFavoriteProducts(productsFinal)
    return getAlgoliaPlpProductsNormalized(productsFinalMerged)
  }
  return getAlgoliaPlpProductsNormalized(products)
}
export const prepareFilterTrackingString = async function(
  idsFiltersCheckedList,
  filterOptionsList,
  facets,
  id,
  isInSearch = false
) {
  const PIPE = '|'

  let filterLists = idsFiltersCheckedList.map(facet => {
    const [facetFilterName, facetFilterValue] = facet.split(':')
    let filterName = capitalizeFirstLetter(facetFilterName)
    let filterValue = ''

    filterOptionsList.some(filter => {
      if (filter.list.some(el => el.id === facet)) {
        let filterGroupName = filter.groupName
        filterValue =
          filterGroupName === 'dashCheckBoxes' ? 'True' : capitalizeFirstLetter(facetFilterValue)
        return true
      }
    })

    return `${filterName}=${filterValue}`
  })

  let sortOptionSelected =
    id !== ''
      ? facets?.sortOptionsList.find(element => element.id == id)
      : facets?.sortOptionsList.find(element => element.selected)

if(!!sortOptionSelected) {
  sortOptionSelected = capitalizeFirstLetter(sortOptionSelected?.label).replace(/-/g, '')
}

  filterLists.push(`orderBy=${sortOptionSelected}`)
  let Search_FacetValues_String = filterLists.join(PIPE)

  let trackingData = {
    Search_ResultItemsQnt: facets?.numResult?.toString() || '0',
    Search_FacetValues_String: Search_FacetValues_String,
  }
  if (isInSearch) {
    trackingData.Search_View = 'SERB'
  }

  return trackingData
}

const capitalizeFirstLetter = str => {
  return str
    .split(' ')
    .map(el => el.charAt(0).toUpperCase() + el.slice(1).toLowerCase())
    .join('')
}

const optimizedFilterList = [
  'attributes_translated.FRAME_SHAPE_FACET',
  'attributes_translated.FRAME_MATERIAL_FACET',
  'attributes_translated.FRAME_FITTING',
  'FRAME_TYPE',
  'attributes_translated.LENS_COLOR_FACET',
  'FACE_SHAPE',
  'attributes_translated.FRAME_MATERIAL_FACET',
  'attributes_translated.BRAND',
  'price',
  'attributes_translated.RX_FILTER',
  'attributes_translated.GENDER',
  'attributes_translated.FRONT_COLOR_FACET',
  'attributes_translated.LENS_TREATMENT_FACET',

]

// https://luxotticaretail.atlassian.net/browse/SGHDP-9995
export const getPlpFilteredCMSBanners = async function(payload) {
  const isPlpDynamicContentActive =
      sessionStorage.getItem('isPlpFacetDynamicContentActive') == 'true'
  if (!isPlpDynamicContentActive) return ''
  else {
    const isFilterSelected = decodeFiltersI18n(payload.checkedFilters).some(filter => {
      const filterID = filter.split(':')[0]
      return optimizedFilterList.includes(filterID)
    })
    if (isFilterSelected) {
      const { locale } = wcs.getStoreConfig()
      let data = {}
      const dynamicEndpoint = window.location.origin + '/webapp/wcs/stores/servlet/PLPTileBanners?'
      const originalUrl = wcs.getEndPoint('getPlpProducts')
      const url = clearUlr(
        originalUrl.split('?')[1],
        /(facet|currentPage|orderBy|isProductNeeded|isChanelCategory|pageSize|responseFormat|currency|viewTaskName|langId|pageView|beginIndex|top)/g
      )
      const finalUrl = dynamicEndpoint + url + '&locale=' + locale + getConfigCMSBanners(payload)
      try {
        data = await axios.get(finalUrl)
      } catch (error) {
        console.error('CMS Banners call failed')
      }

      return data.data
    }
  }
}

export const plpAnalytics = products => {
  const analyticsParams = {
    eventAlgolia: 'viewedObjectIDs',
    queryId: products.queryID,
    objectIDs: products.objectIDs,
    index: products.indexName,
    eventName: products.isSearch ? 'Search - Landing page' : 'PLP - Landing page',
  }

  algoliaAnalyticsEvents(analyticsParams)
}

export const fetchFaqsFromWordLift = async url => {
  const apiUrl = `${WORDLIFT_MAIN_URL}data/${url.replace('https://', 'https/')}`

  try {
    const response = await axios.get(apiUrl)
    if (response.status === 200 && response.data) {
      return response.data
    }
  } catch (error) {
    console.log('Error in API call:', error)
    throw error
  }
}
